import React from "react";
import { Grid2 } from "@mui/material";

import { projectCardsMock } from "./model/constants";
import { ProjectCard } from "./ProjectCard/ProjectCard";

export const ProjectCards: React.FC = () => {
  return (
    <Grid2
      container
      columns={{ xs: 3 }}
      spacing={4}
      direction="row"
      alignItems="stretch"
    >
      {projectCardsMock.map((projectCard) => (
        <ProjectCard
          key={projectCard.title}
          title={projectCard.title}
          description={projectCard.description}
          icon={projectCard.icon}
        />
      ))}
    </Grid2>
  );
};
